// extracted by mini-css-extract-plugin
export default {"overlay":"PostImage-overlay__e751a14a315eac050254"};